export const updateScrollbarStyles = (
    progressElement: HTMLElement | null,
    thumbElement: HTMLElement | null,
    percentage: number,
): void => {
    if (progressElement) {
        progressElement.style.width = `${percentage}%`;
    }
    if (thumbElement) {
        thumbElement.style.left = `${percentage}%`;
    }
};
